import { graphql } from '../../gql'
import { useGQLInfinite } from '../../hooks/GQLUtilityHooks'
import { GroupListItem } from './components/GroupListItem'
import { GroupsFilters } from './components/GroupsFilters'
import { GroupsHeader } from './components/GroupsHeader'
import { useGroupFilters } from '../../lib/hooks/useGroupFilters'
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons'
import { useIntersect } from '../../lib/hooks/useIntersect'
import { Button } from '../../components/shadcn/Button'
import { useEffect } from 'react'

const GroupsListQuery = graphql(`
  query GroupsList($page: Int!, $filters: orderGroupFilters, $sort: String, $direction: String) {
    orderGroups(page: $page, filters: $filters, sort: $sort, direction: $direction) {
      items {
        id
        ...GroupListItem_OrderGroup
      }
      paginator {
        current
        totalCount
        endPage
      }
    }
  }
`)

export const GroupsList = () => {
  // The useGroupFilters hook is ready to be used, but the GraphQL schema for orderGroups does not seem to accept any filter arguments yet.
  // Once the schema is updated, you can pass the 'filters' object to the useGQLInfinite hook.
  const { filters, sort, direction } = useGroupFilters()
  const { measureRef, isIntersecting } = useIntersect()
  const { data, isLoading, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } = useGQLInfinite(
    GroupsListQuery,
    ['orderGroups'],
    {
      page: 1,
      sort,
      direction,
      filters: {
        tags: filters.tags,
        companies: filters.companies ? filters.companies : undefined,
      },
    },
  )

  useEffect(() => {
    if (isIntersecting) {
      fetchNextPage()
    }
  }, [isIntersecting, fetchNextPage])

  return (
    <>
      {/* <GroupsHeader /> */}
      <GroupsFilters />
      <div className="p-4 pt-0">
        <div className="grid gap-4 groupColumns mt-4">
          {data.map(group => (
            <GroupListItem key={group.id} group={group} />
          ))}
          {hasNextPage && (
            <Button
              ref={measureRef}
              id={'next-groups'}
              variant="default"
              icon={faArrowDown}
              title={'Načíst další'}
              disabled={isLoading}
              onClick={() => fetchNextPage()}>
              {'Načíst další'}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}
